<template>
	<div class="timeline-wrapper xs-12">
		<div
			v-for="(item, i) in eventsList"
			:key="i"
			class="flex xs-top mb8 cu2"
			@click="$emit('item:click', item)"
		>
			<!-- Dot -->
			<div class="timeline-dot"></div>

			<!-- Content -->
			<div class="pl4">
				<div :class="item.labelClass || 'fw7 lh125 c2'">{{ item.label }}</div>
				<div :class="item.sublabelClass || 'lh125 c6'">{{ item.sublabel }}</div>
				<div :class="item.contentClass || 'lh125'">{{ item.content }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { gql } from "@/api/utils.js"
import api from "@/api/gql.js"
import dayjs from "dayjs"

export default {
	props: {
		policyId: {
			type: String
		}
	},

	created() {
		this.fetchEvents()
	},

	data() {
		return {
			eventsList: []
		}
	},

	methods: {
		async fetchEvents() {
			const query = gql`
				query policies(
					$where: policyWhereInput
					$skip: Int
					$limit: Int
					$sort: sortInput
				) {
					policies(where: $where, skip: $skip, limit: $limit, sort: $sort) {
						list {
							events {
								timestamp
								by {
									username
								}
								type
							}
						}
					}
				}
			`
			const variables = {
				where: {
					id: this.policyId
				}
			}
			const res = await api({ query, variables })
			if (res?.data?.policies?.list?.[0]?.events) {
				this.eventsList = res.data.policies.list[0].events
					.filter(item => {
						// Remove useless events
						return [
							"acceptEndorsement",
							"rejectEndorsement",
							"creation",
							"complete"
						].includes(item.type)
					})
					.map((item, i) => {
						return {
							...item,
							sublabel: dayjs(item.timestamp).format("YYYY/MM/DD"),
							label: this.$t("events_type." + item.type),
							id: i
						}
					})
				this.eventsList.push({
					label: this.$t("events_type.current"),
					type: "current",
					id: this.eventsList.length
				})
			} else {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: "Oops ! An error occured when time travelling."
					}
				})
			}
		}
	}
}
</script>

<style scoped>
@import "../../../assets/css/tokens.css";

.timeline-wrapper {
	background: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'%3E%3Cline x1='0' y1='100' stroke-width='2' stroke='%23cfd9e3'/%3E%3C/svg%3E")
		9px 0 no-repeat;
}

.timeline-dot {
	width: 20px;
	height: 20px;
	background: var(--color7-dark-2);
	border-radius: 100%;
	border: 4px solid white;
}
</style>
